import { Avatar, Grid, Paper, Stack, Typography } from '@mui/material';
import { IPrescriptionsMedication, IMedication, Statuses } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { GreenVi } from 'Images';
import { isPrescriptionMedication } from 'Utils';

interface PrescriptionMedicationDialogMobileProps {
  medication: IPrescriptionsMedication | IMedication;
  isSupplied: Statuses | undefined;
}

const titleStyle = {
  fontSize: '14px',
  lineHeight: '18px',
  fontWeight: '700',
};

export const PrescriptionMedicationDialogMobile = (
  props: PrescriptionMedicationDialogMobileProps
) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  const medsDictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsHistory
  );

  const { medication, isSupplied } = props;

  return (
    <Paper
      elevation={0}
      sx={{
        padding: '24px 20px',
        marginBottom: '16px',
        boxShadow: '0px 4px 28px rgba(45, 112, 217, 0.15)',
        borderRadius: '16px',
      }}
    >
      <Stack sx={{}}>
        <Typography sx={titleStyle}>
          {dictionary.nameOfTheMedication}
        </Typography>
        <Typography>{medication.medicatioN_NAME}</Typography>
      </Stack>

      <Stack sx={{ marginTop: '16px' }}>
        <Typography sx={titleStyle}>{dictionary.dosageText}</Typography>
        <Typography variant='body1'>
          {medsDictionary.dosageFullDescription(
            medication.dosage,
            medication.doseperday,
            medication.fornumberdays
          )}
        </Typography>
      </Stack>

      {isPrescriptionMedication(medication) && medication.medremark && (
        <Stack sx={{ marginTop: '16px' }}>
          <>
            <Typography sx={titleStyle}>{dictionary.notes}</Typography>
            <Typography variant='body1'>{medication.medremark}</Typography>
          </>
        </Stack>
      )}

      {isPrescriptionMedication(medication) &&
        medication.supplyind === 1 &&
        isSupplied && (
          <Grid
            gap={1}
            item
            container
            alignItems='center'
            sx={{ marginTop: '16px' }}
          >
            <Avatar
              src={GreenVi}
              alt={''}
              sx={{
                width: '16px',
                height: '16px',
              }}
            />
            <Typography component='span'>{dictionary.supplied}</Typography>
          </Grid>
        )}
    </Paper>
  );
};
